import { useEffect, useRef, useState } from 'react';
import fleetApi from '../../services/api.service';
import { buildUrlWithParams } from '../../utils/url.utils';

/**
 * Indicateurs de la liaison avec l'AS400 sur une période (date de tournée).
 */
export default function useGetTourLogsIndicators({ start_date, end_date }) {
  const [indicators, setIndicators] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    abortControllerRef.current?.abort();
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    (async () => {
      try {
        setIsLoading(true);
        setError('');
        const response = await fleetApi.get(
          buildUrlWithParams('/tours/tours-logs/indicators', {
            start_date,
            end_date,
          }),
          { signal: abortController.signal }
        );
        setIndicators(response.data);
      } catch (error) {
        if (!abortController.signal.aborted) {
          setError(
            error?.response?.data?.message ||
              'Impossible de charger les indicateurs.'
          );
        }
      } finally {
        if (!abortController.signal.aborted) {
          setIsLoading(false);
        }
      }
    })();

    return () => abortController.abort();
  }, [start_date, end_date, reloadKey]);

  return {
    indicators,
    error,
    isLoading,
    reload: () => setReloadKey((key) => key + 1),
  };
}
